import ContributorCard from './ContributorCard';

export default ContributorCard;
